(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-bulb-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lc-bulb-picker')) {
    customElements.define('lc-bulb-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('change', () => this.sync());
        this.sync();
      }
      sync() {
        this.querySelectorAll('[data-accessory-item]').forEach((item) => {
          const choice = item.querySelector('[data-bulb-choice]');
          const selected = choice.checked && !choice.disabled;
          item.querySelector('[data-accessory-variant]').disabled = !selected;
          item.querySelector('[data-accessory-form-quantity]').disabled = !selected;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-garage-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lc-garage-accessories')) {
    customElements.define(
      'lc-garage-accessories',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.querySelectorAll('[data-accessory-item]').forEach((item) => {
            const variantInput = item.querySelector('[data-accessory-variant]');
            const quantityInput = item.querySelector('[data-accessory-quantity]');
            const formQuantityInput = item.querySelector('[data-accessory-form-quantity]');
            const decreaseButton = item.querySelector('[data-accessory-decrease]');
            const increaseButton = item.querySelector('[data-accessory-increase]');

            if (!variantInput || !quantityInput || !formQuantityInput) return;

            const sync = () => {
              const quantity = Number.parseInt(quantityInput.value, 10) || 0;
              const selected = !quantityInput.disabled && quantity > 0;
              const maximum = quantityInput.max ? Number.parseInt(quantityInput.max, 10) : Number.POSITIVE_INFINITY;
              variantInput.disabled = !selected;
              formQuantityInput.disabled = !selected;
              formQuantityInput.value = quantity;
              decreaseButton.disabled = quantityInput.disabled || quantity === 0;
              increaseButton.disabled = quantityInput.disabled || quantity >= maximum;
              item.classList.toggle('is-selected', selected);
            };

            const changeQuantity = (direction) => {
              const current = Number.parseInt(quantityInput.value, 10) || 0;
              const step = Number.parseInt(quantityInput.step, 10) || 1;
              const minimum = Number.parseInt(quantityInput.dataset.accessoryMinimum, 10) || 1;
              const maximum = quantityInput.max ? Number.parseInt(quantityInput.max, 10) : Number.POSITIVE_INFINITY;
              let next = current + direction * step;
              if (direction > 0 && current === 0) next = minimum;
              if (direction < 0 && current <= minimum) next = 0;
              quantityInput.value = Math.min(maximum, Math.max(0, next));
              quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            };

            decreaseButton.addEventListener('click', () => changeQuantity(-1));
            increaseButton.addEventListener('click', () => changeQuantity(1));
            quantityInput.addEventListener('change', () => {
              const minimum = Number.parseInt(quantityInput.dataset.accessoryMinimum, 10) || 1;
              const maximum = quantityInput.max ? Number.parseInt(quantityInput.max, 10) : Number.POSITIVE_INFINITY;
              let quantity = Number.parseInt(quantityInput.value, 10) || 0;
              if (quantity > 0 && quantity < minimum) quantity = minimum;
              quantityInput.value = Math.min(maximum, Math.max(0, quantity));
              sync();
            });
            sync();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-led-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lc-led-accessories')) {
    customElements.define('lc-led-accessories', class extends HTMLElement {
      connectedCallback() {
        this.onSelectionChange = () => this.sync();
        this.addEventListener('change', this.onSelectionChange);
        document.addEventListener('submit', this.onSelectionChange, true);
        this.sync();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onSelectionChange);
        document.removeEventListener('submit', this.onSelectionChange, true);
        this.mirror?.remove();
      }
      sync() {
        const form = this.closest('.m-main-product--info')?.querySelector('.m-product-form--main form');
        if (!form) return;
        if (!this.mirror?.isConnected || this.mirror.parentElement !== form) {
          this.mirror?.remove();
          this.mirror = document.createElement('div');
          this.mirror.hidden = true;
          this.mirror.setAttribute('data-lc-led-accessory-selection', '');
          form.append(this.mirror);
        }
        const quantity = Number.parseInt(new FormData(form).get('quantity'), 10) || 1;
        this.mirror.replaceChildren();
        this.querySelectorAll('[data-lc-accessory-category]').forEach((group) => {
          const selected = group.querySelector('[data-lc-accessory-choice]:checked:not(:disabled)');
          if (!selected || selected.value === 'none') return;
          const item = document.createElement('div');
          item.setAttribute('data-accessory-item', '');
          const variantInput = document.createElement('input');
          variantInput.type = 'hidden';
          variantInput.value = selected.value;
          variantInput.setAttribute('data-accessory-variant', '');
          const quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.value = quantity;
          quantityInput.setAttribute('data-accessory-form-quantity', '');
          item.append(variantInput, quantityInput);
          this.mirror.append(item);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-size-options"] && !Shopify.designMode) return;
  try {
    function lcActivateSizeOption(option) {
    const group = option.closest('[data-lc-size-options]');
    const card = option.closest('.m-product-card');

    if (!group || !card) return;

    group.querySelectorAll('[data-lc-size-option]').forEach((sizeOption) => {
      sizeOption.removeAttribute('aria-current');
    });
    option.setAttribute('aria-current', 'true');

    const variantUrl = new URL(option.href, window.location.origin);
    const variantId = variantUrl.searchParams.get('variant');
    const productPath = group.getAttribute('data-lc-product-path');

    if (!variantId || !productPath) return;

    card.querySelectorAll(`a[href*="${productPath}"]`).forEach((link) => {
      if (link.matches('[data-lc-size-option]')) return;

      const productUrl = new URL(link.href, window.location.origin);
      productUrl.searchParams.set('variant', variantId);
      link.href = `${productUrl.pathname}${productUrl.search}${productUrl.hash}`;
    });

    const variantPrice = option.getAttribute('data-lc-variant-price');
    if (variantPrice) {
      card.querySelectorAll('.m-product-card__price span.m-price-item').forEach((priceElement) => {
        priceElement.textContent = variantPrice;
      });
    }

    const variantImage = option.getAttribute('data-lc-variant-image');
    const variantImageSrcset = option.getAttribute('data-lc-variant-image-srcset');
    const variantImageAlt = option.getAttribute('data-lc-variant-image-alt');

    if (variantImage) {
      card.querySelectorAll('.m-product-card__media img').forEach((image) => {
        image.setAttribute('src', variantImage);
        if (variantImageSrcset) image.setAttribute('srcset', variantImageSrcset);
        if (variantImageAlt) image.setAttribute('alt', variantImageAlt);
      });
    }
  }

  function lcHandleSizeOptionChange(event) {
    const option = event.target?.closest?.('[data-lc-size-option]');
    if (option) lcActivateSizeOption(option);
  }

  document.addEventListener('mouseover', lcHandleSizeOptionChange);
  document.addEventListener('focusin', lcHandleSizeOptionChange);
  } catch(e) { console.error(e); }
})();

})();
